export default {
	anteriores:[
		{
			"id": "one",
			"anio" : "Fracciones 2018",
			"trimestre1": "/Transparencia/Fracciones/Fracciones%202018/1er%20Trimestre.zip",
			"trimestre2": "/Transparencia/Fracciones/Fracciones%202018/2do%20Trimestre.zip",
			"trimestre3": "/Transparencia/Fracciones/Fracciones%202018/3er%20Trimestre.zip",
			"trimestre4": "/Transparencia/Fracciones/Fracciones%202018/4to%20Trimestre.zip"
		},
		{
			"id": "two",
			"anio" : "Fracciones 2019",
			"trimestre1": "/Transparencia/Fracciones/Fracciones%202019/1er%20Treimestre.zip",
			"trimestre2": "/Transparencia/Fracciones/Fracciones%202019/2do%20Trimestre.zip",
			"trimestre3": "/Transparencia/Fracciones/Fracciones%202019/3er%20Trimestre.zip",
			"trimestre4": "/Transparencia/Fracciones/Fracciones%202019/4to%20Trimestre.zip",
		},
		{
			"id": "three",
			"anio" : "Fracciones 2020",
			"trimestre1": "/Transparencia/Fracciones/Fracciones%202020/1er%20Trimestre.zip",
			"trimestre2": "/Transparencia/Fracciones/Fracciones%202020/2do%20Trimestre.zip",
			"trimestre3": "/Transparencia/Fracciones/Fracciones%202020/3er%20Trimestre.zip",
			"trimestre4": "/Transparencia/Fracciones/Fracciones%202020/4er%20Trimestre.zip",
		},
		{
			"id": "four",
			"anio" : "Fracciones 2021",
			"trimestre1": "/Transparencia/Fracciones/fracciones%202021/1T.zip",
			"trimestre2": "/Transparencia/Fracciones/fracciones%202021/2T.zip",
			"trimestre3": "/Transparencia/Fracciones/fracciones%202021/3T.zip",
			"trimestre4": "/Transparencia/Fracciones/fracciones%202021/4T.zip",
		},
		{
			"id": "five",
			"anio" : "Fracciones 2022",
			"trimestre1": "/Transparencia/Fracciones/fracciones%202022/PRIMER%20TRIMESTRE.zip",
			"trimestre2": "/Transparencia/Fracciones/fracciones%202022/SEGUNDO%20TRIMESTRE.zip",
			"trimestre3": "/Transparencia/Fracciones/fracciones%202022/TERCER%20TRIMESTRE.zip",
			"trimestre4": "/Transparencia/Fracciones/fracciones%202022/CUARTO%20TRIMESTRE.rar"
		},
		{
			"id": "six",
			"anio" : "Fracciones 2023",
			"trimestre1": "/Transparencia/Fracciones/fracciones2023/1T.zip",
			"trimestre2": "/Transparencia/Fracciones/fracciones2023/2T.zip",
			"trimestre3": "/Transparencia/Fracciones/fracciones2023/3T.zip",
			"trimestre4": "/Transparencia/Fracciones/fracciones2023/4T.zip",

		},
		{
			"id": "seven",
			"anio" : "Fracciones 2024",
			"trimestre1": "/Transparencia/Fracciones/fracciones2024/1T.zip",
			"trimestre2": "/Transparencia/Fracciones/fracciones2024/2T.zip",
			"trimestre3": "/Transparencia/Fracciones/fracciones2024/3T.zip",
			"trimestre4": "/Transparencia/Fracciones/fracciones2024/4T.zip",
		},
		{
			"id": "eight",
			"anio" : "Fracciones 2025",
			"trimestre1": "/Transparencia/Fracciones/fracciones2025/1T.zip",
			"trimestre2": "/Transparencia/Fracciones/fracciones2025/2T.zip",
			"trimestre3": "/Transparencia/Fracciones/fracciones2025/3T.zip",
			"trimestre4": "/Transparencia/Fracciones/fracciones2025/4T.zip",
			
		},
	]
}